import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Editor } from '@tinymce/tinymce-react';
import autobind from 'autobind-decorator';
import editorConfig from './EditorConfig';
import './plugins/daumblog-converter';
import './plugins/tistory-replacer';
import './plugins/tistory-attacher';
import './plugins/tistory-plugins';
import './plugins/tistory-mode';
import { hideFooter, notifyEditorInitialized, showFooter, updateEditorMode, updateToolbarLeft } from '../../../actions';
import { changeContent, changeThumbnail, increaseUploadProgressCount, decreaseUploadProgressCount } from '../../../actions/post';
import WindowEventHelper from '../../../lib/WindowEventHelper';
import { CHARMAP } from '../../../constants/data';
import { EDITOR_MODE_MARKDOWN } from '../../../constants/EditorMode';
import AttachmentUrlConverter from '../../../lib/attachment/AttachmentUrlConverter';

@connect(state => ({
  post: state.post.newPost,
  blog: state.blog,
  canPublish: state.post.uploadProgressCount === 0,
}), dispatch => ({
  handleChangeContent: content => {
    dispatch(changeContent(content));
  },
  handleUpdateEditorMode: mode => {
    dispatch(updateEditorMode(mode));
  },
  handleUpdateToolbarLeft: left => {
    dispatch(updateToolbarLeft(left));
  },
  handleChangeThumbnail: thumbnail => {
    dispatch(changeThumbnail(thumbnail));
  },
  handleHideFooter: () => {
    dispatch(hideFooter());
  },
  handleShowFooter: () => {
    dispatch(showFooter());
  },
  handleIncreaseUploadProgressCount: () => {
    dispatch(increaseUploadProgressCount());
  },
  handleDecreaseUploadProgressCount: () => {
    dispatch(decreaseUploadProgressCount());
  },
  dispatchEditorInitialized: () => {
    dispatch(notifyEditorInitialized());
  },
}))
class ContentEditor extends Component {
  componentDidMount () {
    WindowEventHelper.add('resize', this.handleWindowResize);
  }

  componentWillUnmount () {
    WindowEventHelper.remove('resize', this.handleWindowResize);
  }

  shouldComponentUpdate (nextProps, nextState, nextContext) {
    return false;
  }

  @autobind
  handleWindowResize () {
    const { handleUpdateToolbarLeft } = this.props;
    const [btnCategory] = document.getElementsByClassName('btn-category');
    const [topToolbar] = document.getElementsByClassName('mce-top-part');
    if (btnCategory && topToolbar) {
      const toolbarLeft = btnCategory.getBoundingClientRect().left - 6;
      topToolbar.style.left = `${toolbarLeft}px`;
      topToolbar.style.transform = 'none';
      handleUpdateToolbarLeft(toolbarLeft);
    }
  }

  @autobind
  handleAttachmentUploadStatus (info) {
    const { handleIncreaseUploadProgressCount, handleDecreaseUploadProgressCount } = this.props;
    switch (info.status) {
      case 'start':
        handleIncreaseUploadProgressCount();
        break;
      case 'end':
        handleDecreaseUploadProgressCount();
        break;
      default:
        break;
    }
  }

  @autobind
  handleChangeContent (e, editor) {
    const { handleChangeContent, canPublish } = this.props;
    if (!canPublish) {
      return;
    }
    handleChangeContent(editor._getkContent());
  }

  @autobind
  handleUpdateEditorMode (mode) {
    const { handleUpdateEditorMode, canPublish } = this.props;
    if (!canPublish) {
      alert('파일을 업로드하는 중에는 에디터 전환을 할 수 없습니다.');
      return;
    }

    if (mode === EDITOR_MODE_MARKDOWN && !confirm('마크다운 모드에서는 일부 지원되지 않는 기능이 있습니다.\n전환하시겠습니까?')) {
      return;
    }
    handleUpdateEditorMode(mode);
  }

  setAccessibilityAttrs (editor) {
    const iframe = editor.contentWindow.frameElement;
    const editorBody = iframe.contentDocument.querySelector('#tinymce');
    editorBody.setAttribute('role', 'textbox');
    editorBody.setAttribute('aria-multiline', true);
    editorBody.setAttribute('aria-label', '글 내용 입력');
  }

  render () {
    const {
      editorId, post, blog, handleChangeThumbnail,
      onOpenTemplate, onToggleGooglePhotos,
      handleHideFooter, handleShowFooter,
      dispatchEditorInitialized,
      onOpenRevenue,
      onOpenYoutubeModal,
      onOpenLayerPluginModal,
    } = this.props;

    const config = editorConfig({
      charmapItems: CHARMAP,
      blogManageUrl: blog.manageUrl,
      openGooglePhotosHandler: onToggleGooglePhotos,
      width: 880,
      modeChangeHandler: this.handleUpdateEditorMode,
      thumbnailChangeHandler: handleChangeThumbnail,
      attachmentUploadStatusHandler: this.handleAttachmentUploadStatus,
      imageToThumbnail: AttachmentUrlConverter.toContentThumbnail,
      openTemplateHandler: onOpenTemplate,
      tistoryPlugins: blog.plugins,
      uselessMargin: blog.uselessMargin,
      onGrammerCheckStart: handleHideFooter,
      onGrammerCheckFinish: handleShowFooter,
      openRevenueHandler: onOpenRevenue,
      openYoutubeModal: onOpenYoutubeModal,
      openLayerPluginModal: onOpenLayerPluginModal,

      onInit: editor => {
        dispatchEditorInitialized();
        this.handleWindowResize();
        editor.focus();
        window.activeEditor = editor;
        this.setAccessibilityAttrs(editor);
      },
    });

    return (
      <Editor
        id={editorId}
        initialValue={post.content}
        onChange={this.handleChangeContent}
        init={config}
      />
    );
  }
}

export default ContentEditor;
